import styled from '@emotion/styled'
import { gsColors } from '../../styles/Variables';
import { mq } from '../../helpers';
import { Section } from '../../styles/Components';

export const AgreementLink = styled.a`
  color: inherit;
  text-decoration: underline;
`;

export const FieldSubtext = styled.p`
  font-family: Euclid;
  font-size: 13px;
  line-height: 1.2;
  letter-spacing: 0.26px;
  color: ${gsColors.darkGrey};
  margin: 4px 0 0;
`;

export const SignUpSection = styled(Section)`
  display: flex;
  justify-content: center;
   margin: 0 auto;
   // width: 50%;
   max-width: 500px;
   min-width: 350px;
   order: 2;

   ${mq('max', '768px')} {
     min-width: 0;
     max-width: initial;
     width: 100%;
     padding: 0 16px 30px;
   }

    form {
      margin: 0;
      width: 100%;
    }

   .otp-login {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* entry-screen identifier field: fill to the button width (400px max),
       with a 50px gap under the subtext (design spec) */
    .email-container {
      width: 100%;
      margin-top: 50px;
    }

    .field-container.phone-input-container {
      margin-top: 50px;
    }

    .continue-button {
      margin-top: 40px;
      max-width: 400px;
      padding: 14px 5px;

      ${mq('max', '768px')} {
        max-width: 100%;
      }
    }

    .text-agreement {
      max-width: 400px;
      margin: 40px auto 0;
      font-size: 12px;
      line-height: 1.38;
      letter-spacing: normal;
      text-align: center;
    }
   }

   .form-control {
     font-family: Euclid, sans-serif;
     font-size: 16px;
     line-height: 20px;
     padding: 10px 0;
     width: 100%;

     ::placeholder {
       color: ${gsColors.paleSlate};
     }

     &:focus {
       outline: 0;
     }

     &.name-first,
     &.phone-number,
     &.email-address,
     &.password {
       padding-left: 30px;
     }
   }

   .remember-me-toggle{
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;

      button{
        padding: 15px 0;
        font-size: 12px;
        min-width: 0;
      }

      div > label {
        display: flex;
        padding: 0;

        .remember-me-text {
          font-family: Euclid, sans-serif;
          color: black;
          font-size: 16px;
          font-weight: 400;
          padding-left: 12px;
        }
      }

      .remember-me-text{
        color: ${gsColors.darkEggplant};
        font-size: 13px;
        padding-right: 5px;
      }
    }

  /* locked (pre-filled, verified) signup fields render read-only in Figma's muted grey,
     not disabled-italic. Scoped to #sign-up-form so the read-only OTP boxes are unaffected. */
  #sign-up-form input:read-only {
    color: ${gsColors.darkGrey};
  }

  .field-container {
    margin-top: 24px;

    ${mq('min', '768px')} {
      margin-left: auto;
      margin-right: auto;
      max-width: 400px;
    }

    .error-message {
      color: ${gsColors.errorRed};
      font-size: 16px !important;
    }

    .input-error {
      color: ${gsColors.errorRed};
      border-bottom: 1px solid ${gsColors.errorRed} !important;
    }

    &.name {
      display: flex;
      justify-content: space-between;

      > div {
        width: calc(50% - 10px);
      }

      .name-first-container {
        position: relative;

        img {
          position: absolute;
          top: 11px;
          left: 0;
        }
      }
    }

    &.phone-container, &.password-container, &.email-container {
      position: relative;

      img {
        position: absolute;
        left: 0;
      }
    }

    &.phone-container > img {
      top: 11px;
    }

    &.email-container > img {
      top: 14px;
    }

    &.password-container > img {
      top: 10.5px;
    }

    &.phone-input-container {
      margin-top: 24px;
      width: 100%;
      position: relative;

      label {
        color: ${gsColors.meredithGrey};
        opacity: 0.5;
        position: absolute;
        font-family: 'Euclid';
        font-size: 18px;
        // z-index: -1;
        top: 10px;
        transition: all .1s ease;

        &.active {
          font-size: 11px;
          top: -2px;
          left: 0;
          line-height: 120%;
          letter-spacing: 0.22px;
        }
      }
    }

    &.terms-container {
      margin-top: 40px;
      margin-bottom: 40px;

      div > label {
        padding: 0;
        display: flex;
        align-items: center;

        .box {
          margin-right: 20px;
        }

        span {
          font-family: Euclid;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            line-height: 120%;
            letter-spacing: 0.72px;
          a {
            margin: 0 3px;
            color: ${gsColors.cobalt};
          }
        }
      }
    }
  }

   .invalid-feedback {
     color: ${gsColors.errorRed};
     font-family: Euclid;
     font-size: 16px;
     font-weight: 400;
     margin-top: 8px 0 0;
     line-height: 20px;

     ${mq('max', '768px')} {
      font-size: 13px;
     };
   }

   .field-hint {
     color: ${gsColors.venus};
     font-family: Euclid;
     font-size: 12px;
     font-style: normal;
     font-weight: 400;
     line-height: 138%; /* 16.56px */
     margin-top: 8px;

     ${mq('min', '768px')} {
       text-align: left;
     }
   }

   .divider-with-text {
     width: 100%;
     line-height: 20px;
     margin: 20px 0;
     position: relative;
     text-align: center;

     ${mq('min', '768px')} {
       margin-left: auto;
       margin-right: auto;
       max-width: 330px;
     }

     &:before {
       position: absolute;
       top: 50%;
       transform: translate3d(0, -50%, 0);
       background-color: ${gsColors.textGrey};
       content: '';
       left: 0;
       width: 100%;
       height: 1px;
     }

     span {
       background-color: ${gsColors.white};
       color: ${gsColors.saltBox};
       display: inline-block;
       padding: 0 20px;
       position: relative;
       text-align: center;
       font-family: Euclid;
       font-size: 14px;
       font-style: normal;
       font-weight: 400;
       line-height: 138%;
     }
   }

   .fb-login {
      border-color: ${gsColors.black};
      span {
        color: ${gsColors.black};
      }
   }
 `;

export const SocialButtonsRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: center;
  gap: 12px;
  width: 100%;

  ${mq('max', '768px')} {
    flex-direction: column;
    gap: 10px;
  }

  .social-button {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 127px;
    height: 54px;
    padding: 0 16px;
    border: 1px solid ${gsColors.black};
    border-radius: 0;
    background: ${gsColors.white};
    color: ${gsColors.black};
    font-family: Euclid, sans-serif;
    font-size: 17px;
    font-weight: 600;
    line-height: normal;
    cursor: pointer;

    ${mq('max', '768px')} {
      width: 100%;
    }

    &:hover {
      border-color: ${gsColors.black};
    }
  }

  .google-button {
    gap: 10px;
  }

  .apple-button {
    gap: 10px;

    .apple-icon {
      margin-top: -2px;
    }

    &:hover {
      border-color: ${gsColors.black};
    }
  }
`;
